export default "__VITE_ASSET__CuTSeF1x__"